import { render, staticRenderFns } from "./Wealth.vue?vue&type=template&id=2a29e8fc"
import script from "./Wealth.vue?vue&type=script&lang=js"
export * from "./Wealth.vue?vue&type=script&lang=js"
import style0 from "./Wealth.vue?vue&type=style&index=0&id=2a29e8fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports